module.exports = __webpack_public_path__ + "assets/img/thumb-Quorn-Pillar-Page-Resource.e0c8973f.webp";